import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { CancelPermitToDig, CancelPermitToDigVariables } from "./__generated__/CancelPermitToDig";
import { PERMIT_TO_DIG_ALL_FIELDS } from "../fragments/permitToDig";

const CANCEL_PERMIT = gql`
  ${PERMIT_TO_DIG_ALL_FIELDS}
  mutation CancelPermitToDig($id: String!) {
    cancelPermitToDig(input: { id: $id }) {
      permitToDig {
        ...PermitToDigAllFields
      }
    }
  }
`;

export function useCancelPermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    CancelPermitToDig,
    CancelPermitToDigVariables
  >(CANCEL_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
